import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const NotificationPanel = () => {
  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* NOTIFICATIONS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Notifications</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Info Notification</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="bg-blue-900 border border-blue-600 rounded p-3 text-sm">
                <p className="text-blue-300 font-medium">? Information</p>
                <p className="text-blue-200 text-xs mt-1">This is an info message</p>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="bg-blue-900 border border-blue-600 rounded p-3">
  <p className="text-blue-300 font-medium">? Information</p>
  <p className="text-blue-200 text-sm mt-1">This is an info message</p>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Success Notification</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="bg-green-900 border border-green-600 rounded p-3 text-sm">
                <p className="text-green-300 font-medium">? Success</p>
                <p className="text-green-200 text-xs mt-1">Operation completed</p>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="bg-green-900 border border-green-600 rounded p-3">
  <p className="text-green-300 font-medium">? Success</p>
  <p className="text-green-200 text-sm mt-1">Operation completed</p>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Warning Notification</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="bg-yellow-900 border border-yellow-600 rounded p-3 text-sm">
                <p className="text-yellow-300 font-medium">? Warning</p>
                <p className="text-yellow-200 text-xs mt-1">Please check this</p>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="bg-yellow-900 border border-yellow-600 rounded p-3">
  <p className="text-yellow-300 font-medium">? Warning</p>
  <p className="text-yellow-200 text-sm mt-1">Please check this</p>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Error Notification</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="bg-red-900 border border-red-600 rounded p-3 text-sm">
                <p className="text-red-300 font-medium">? Error</p>
                <p className="text-red-200 text-xs mt-1">Something went wrong</p>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="bg-red-900 border border-red-600 rounded p-3">
  <p className="text-red-300 font-medium">? Error</p>
  <p className="text-red-200 text-sm mt-1">Something went wrong</p>
</div>`} />
          </div>
        </div>
      </div>

      {/* CUSTOM ALERTS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Custom Alerts</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Notification with Action</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="bg-amber-900 border border-amber-600 rounded p-3">
                <div className="flex justify-between">
                  <div><p className="text-amber-300 font-medium text-sm">New Update</p><p className="text-amber-200 text-xs mt-1">Version 2.0 ready</p></div>
                  <button className="text-amber-300 hover:text-amber-200 text-lg">?</button>
                </div>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="bg-amber-900 rounded p-3 flex justify-between">
  <div>
    <p className="text-amber-300 font-medium">New Update</p>
    <p className="text-amber-200 text-sm mt-1">Version 2.0 ready</p>
  </div>
  <button className="text-amber-300">?</button>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Notification Stack</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600 space-y-2">
              <div className="bg-slate-700 rounded p-2 border-l-4 border-amber-400"><p className="text-slate-300 text-xs">Message 1</p></div>
              <div className="bg-slate-700 rounded p-2 border-l-4 border-orange-400"><p className="text-slate-300 text-xs">Message 2</p></div>
              <div className="bg-slate-700 rounded p-2 border-l-4 border-amber-500"><p className="text-slate-300 text-xs">Message 3</p></div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="space-y-2">
  {notifications.map(n => (
    <div key={n.id} className="bg-slate-700 rounded p-2 border-l-4" style={{borderColor: n.color}}>
      <p className="text-slate-300 text-xs">{n.message}</p>
    </div>
  ))}
</div>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationPanel;


